module.exports = __webpack_public_path__ + "static/media/signage-indoor-img33.4c97b551.jpg";